//# sourceMappingURL=is-webview.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/datepicker/helpers/is-webview.js
// module id = 1101
// module chunks = 0